import React, { useState, createContext } from 'react'
import { Box, IconButton, Tooltip, Button } from "@mui/material"
import TableRowsIcon from '@mui/icons-material/TableRows';
import PieChartIcon from '@mui/icons-material/PieChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import HexagonIcon from '@mui/icons-material/Hexagon';

export const DashboardContext = createContext()

const buttonDefinition = {
    //'table'  : { name: 'Tabela', icon: (<TableRowsIcon />) },
    'pie'    : { name: 'Pizza', icon: (<PieChartIcon />) },
    'bar'    : { name: 'Barras', icon: (<BarChartIcon />)},
    'hexagon': {name: 'Polígono', icon: (<HexagonIcon />)}
}

const DashboardCard = ({ save, label, children }) => {

    const [type, setType] = useState(localStorage.getItem(`${save}-graph`) || 'bar')

    return (
        <DashboardContext.Provider value={{ type }}>
            <Box className='journey-dashboard-card' sx={{ padding: '1rem' }}>
                <Box className='journey-dashboard-card-header'>
                    <Box className='journey-dashboard-card-label'>{label}</Box>
                    <Box className='journey-dashboard-card-graphselector'>
                        {Object.entries(buttonDefinition).map(([key, value]) => (
                            <Tooltip title={value.name}>
                                <span>
                                    <Button sx={{ minWidth: '2.5rem !important', width: '2.5rem' }}
                                        onClick={() => {setType(key); localStorage.setItem(`${save}-graph`, key)}}
                                    variant={key === type ? 'contained' : ''}>
                                    {value.icon}
                                </Button>
                            </span>
                            </Tooltip>
                        ))}
                </Box>
            </Box>
            {children}
        </Box>
        </DashboardContext.Provider >
    )
}

export default DashboardCard